__turbopack_context__.v({
  "className": "roboto_65858e07-module__bBqnDW__className",
});
